import { Checkbox } from "@constants/variables";

/**
 * value が Checkbox.ON の場合は true を返す
 */
const determineTrueOrFalse = (value?: Checkbox | number | null): boolean =>
  `${value}` === Checkbox.ON;

export default determineTrueOrFalse;
